import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CreditCard } from "lucide-react";

// Bannière de rappel paiement mobile money en attente
export default function PendingPaymentBanner({ pendingPayment, onDismiss }) {
  if (!pendingPayment) return null;
  const paymentHref = pendingPayment.payment_url || pendingPayment.wave_launch_url;
  return (
    <Card className="border-2 border-[#D4AF37] bg-gradient-to-r from-[#D4AF37]/10 to-[#003594]/10" data-testid="pending-payment-banner">
      <CardContent className="py-5">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-[#D4AF37] text-white flex items-center justify-center flex-shrink-0">
              <CreditCard className="w-6 h-6" />
            </div>
            <div>
              <p className="font-bold text-[#003380]">Finalisez votre paiement</p>
              <p className="text-sm text-gray-700">
                Votre commande est en attente de paiement. Cliquez ci-dessous pour ouvrir l'application de paiement.
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            {paymentHref && (
              <a
                href={paymentHref}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] hover:bg-[#B8941F] text-white px-5 py-2.5 rounded-full font-semibold text-sm shadow"
                data-testid="open-payment-url-btn"
              >
                Ouvrir le paiement
              </a>
            )}
            <Button
              onClick={onDismiss}
              variant="outline"
              size="sm"
              className="rounded-full"
              data-testid="dismiss-payment-btn"
            >
              Plus tard
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
